import * as React from 'react';
import { Field } from 'react-final-form';
import { AnyObject } from 'final-form';

interface IFormTextboxProps {
    name: string;
    label?: string;
    fillWidth?: boolean;
    placeholder?: string;
    disabled?: boolean;
    value?: string;
    isPassword?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    id?: string;
}

export default class FormTextbox extends React.Component<IFormTextboxProps> {
    constructor(props: IFormTextboxProps) {
        super(props);

        this.inputRef = React.createRef<HTMLInputElement>();
    }

    static defaultProps = {
        fillWidth: true,
    };

    inputRef: React.RefObject<HTMLInputElement>;

    onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.props.onEnter && event.key === 'Enter') {
            this.props.onEnter(event);
        }
    };

    onChange = (event: React.ChangeEvent<HTMLInputElement>, input: AnyObject) => {
        input.onChange(event);
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    };

    render() {
        const field = (
            <Field name={this.props.name}>
                {({ input }) => (
                    <input
                        ref={this.inputRef}
                        {...input}
                        placeholder={this.props.placeholder}
                        className={`bp3-input`}
                        disabled={this.props.disabled}
                        onChange={(e) => this.onChange(e, input)}
                        onKeyPress={this.onKeyPress}
                        value={this.props.value}
                        type={this.props.isPassword ? 'password' : 'text'}
                        id={this.props.id ? this.props.id : undefined}
                    />
                )}
            </Field>
        );

        if (this.props.label) {
            return (
                <div className={`bp3-form-group bp3-inline ${this.props.fillWidth ? 'bp3-fill' : ''}`}>
                    <label className="bp3-label">{this.props.label}</label>
                    <div className={`bp3-form-content ${this.props.fillWidth ? 'bp3-fill' : ''}`}>
                        <div className="bp3-input-group bp3-inline">{field}</div>
                    </div>
                </div>
            );
        } else {
            return field;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/forms/FormTextbox.tsx